import React from "react";
import { TodoCounter } from './Components/TodoCounter/TodoCounter';
import { TodoSearch } from './Components/TodoSearch/TodoSearch';
import { CreateTodoButton } from './Components/CreateTodoButton/CreateTodoButton';
import { TodoList } from './Components/TodoList/TodoList';
import { TodoItem } from './Components/TodoItem/TodoItem';
import { TodoContext } from "./Utils/TodoContext";
import { Todo } from "./DTOs/TodoObject";
import { Modal } from "./Components/Modal/Modal";
import { TodoForm } from "./Components/TodoForm/TodoForm";
import { Presentation } from "./Components/Presentation/Presentation";
import './AppUI.css';

class AppUIProps {
  public loading?: boolean | undefined;
  public error?: boolean | undefined;
  public totalTodos?: number;
  public completedTodos?: number;
  public searchValue?: string;
  public setSearchValue?: any;
  public searchedTodos?: Todo[];
  public completeTodo?: any;
  public deleteTodo?: any;
  public openModal?: boolean;
  public setOpenModal?: any;

  constructor(data: AppUIProps) {
    this.loading = data.loading;
    this.error = data.error;
    this.totalTodos = data.totalTodos;
    this.completedTodos = data.completedTodos;
    this.searchValue = data.searchValue;
    this.setSearchValue = data.setSearchValue;
    this.searchedTodos = data.searchedTodos;
    this.completeTodo = data.completeTodo;
    this.deleteTodo = data.deleteTodo;
    this.openModal = data.openModal;
    this.setOpenModal = data.setOpenModal;
  }
}

function AppUI() {

  const {
    error,
    loading,
    searchedTodos,
    completeTodo,
    deleteTodo,
    openModal,
    setOpenModal
  }: AppUIProps = React.useContext(TodoContext);

  return (
    // <React.Fragment>
    <div className="appContent">
      <div className="descriptionSection">
        <Presentation />
      </div>
      <div className="listSection">
        <TodoCounter />
        <TodoSearch />      
        <TodoList>
          {error && <p>There was an Error...</p>}
          {/* {loading && <p>Loading...</p>} */}
          { loading && <div className="loader-container"><div className="spinner">H</div></div> }
          {(!loading && !! searchedTodos && !searchedTodos.length) && <p>Crea tu primer TODO</p>}

          {!!searchedTodos && searchedTodos.map(todo => (
            <TodoItem
              key={todo.text}
              text={todo.text}
              completed={todo.completed}
              onComplete={() => completeTodo(todo.text)}
              onDelete={() => deleteTodo(todo.text)}
            />
          ))}
        </TodoList>
        <CreateTodoButton
          setOpenModal={setOpenModal}
          />
      </div>
      {!!openModal && (
        <Modal>
          <TodoForm />
        </Modal>
      )}
    </div>
    // {/* </React.Fragment> */}
  );
}

export { AppUI };